/**
 * Web Vitals Performance Tracking
 *
 * Tracks Core Web Vitals metrics and sends them to PostHog
 * Metrics: LCP, FID, CLS, INP, FCP, TTFB
 */

import { onCLS, onFID, onLCP, onFCP, onTTFB, onINP } from 'web-vitals';
import { posthog } from './analytics';

let isInitialized = false;

/**
 * Initialize Web Vitals tracking
 * Call this once after PostHog is initialized
 */
export function initWebVitals() {
  if (isInitialized) return;

  const reportMetric = (metric) => {
    // Check if posthog is available
    if (!posthog || typeof posthog.capture !== 'function') {
      console.log('[WebVitals] PostHog not ready, skipping metric:', metric.name);
      return;
    }

    posthog.capture('web_vital', {
      metric_name: metric.name,
      metric_id: metric.id,
      value: metric.value,
      delta: metric.delta,
      rating: metric.rating, // 'good', 'needs-improvement', or 'poor'
      navigation_type: metric.navigationType,
      page: window.location.pathname
    });

    // Log for debugging
    console.log(`[WebVitals] ${metric.name}: ${metric.value.toFixed(2)} (${metric.rating})`);
  };

  try {
    // Largest Contentful Paint - measures loading performance
    onLCP(reportMetric);

    // First Input Delay - measures interactivity
    onFID(reportMetric);

    // Cumulative Layout Shift - measures visual stability
    onCLS(reportMetric);

    // Interaction to Next Paint - measures responsiveness
    onINP(reportMetric);

    // First Contentful Paint - measures perceived load speed
    onFCP(reportMetric);

    // Time to First Byte - measures server response time
    onTTFB(reportMetric);

    isInitialized = true;
    console.log('[WebVitals] Performance tracking initialized');
  } catch (error) {
    console.error('[WebVitals] Failed to initialize:', error);
  }
}

export default { initWebVitals };
